module.exports = __webpack_public_path__ + "img/capa1.b7ec8c5b.webp";